import locationHelperBuilder from "redux-auth-wrapper/history4/locationHelper";
import { connectedRouterRedirect } from "redux-auth-wrapper/history4/redirect";
import { ROUTES } from "../configs/routes";
import { REQUEST_NUMBER } from "../constants/storage";
import { store } from "../store";
import { UtilsBrowser } from "../utils/UtilsBrowser";
import { Cookie } from "./storage";

const locationHelper = locationHelperBuilder({});

export const nonAuth = connectedRouterRedirect({
  authenticatedSelector: () => {
    return !UtilsBrowser.isInternetExplorer();
  },
  redirectPath: (_, ownProps) => {
    return UtilsBrowser.isInternetExplorer()
      ? ROUTES.ERROR_IE
      : locationHelper.getRedirectQueryParam(ownProps) || ROUTES.ROOT;
  },
  wrapperDisplayName: "UserIsNotAuthenticated",
});

export const auth = connectedRouterRedirect({
  authenticatedSelector: (_, ownProps: any) => {
    const isLoggedIn = store.getState().auth.isLoggedIn;

    // Cookie.remove(REQUEST_NUMBER);

    if (ownProps.match.params.requestNumber && !isLoggedIn) {
      Cookie.set(REQUEST_NUMBER, ownProps.match.params.requestNumber);
    }

    return isLoggedIn;
  },
  redirectPath: ROUTES.ROOT, // NOTE: Redirected back to home page so that user will be presented login options (email/SA)
  wrapperDisplayName: "UserIsAuthenticated",
});

export const unsupportedBrowserOnly = connectedRouterRedirect({
  authenticatedSelector: () => {
    return UtilsBrowser.isInternetExplorer();
  },
  redirectPath: ROUTES.ROOT,
});
